import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'

const styles = theme => ({
  card: {
    width: '450px',
    maxWidth: '100%',
    maxHeight: '85%',
    padding: 5,
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: 'rgba(255, 255, 255, 1)',
    borderRadius: 5,
    overflow: 'visible',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': { width: '0px' }
  },
  root: {
  }
})

const ServiceDrawerCard = ({ children, classes }) => {
  return <Card className={classes.card} classes={{ root: classes.root }}>{children}</Card>
}

export default withStyles(styles)(ServiceDrawerCard)



// WEBPACK FOOTER //
// ./src/components/ServiceDrawerCard.js